"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = require("styled-components");
const styled = __importStar(require("./styled"));
const Typography_1 = __importStar(require("@/Components/UI/Typography"));
const Types_1 = require("@/Types");
const Utils_1 = require("@/Utils");
const ProductLogo_1 = __importDefault(require("@/Components/UI/ProductLogo"));
const Skeleton_1 = __importDefault(require("@/Components/UI/Skeleton/Skeleton"));
const useTranslate_1 = require("@/Hooks/useTranslate");
const Text = ({ variant, type, showMoreButton, listRef, canSeePrice, isOpen, setIsOpen, onClick }) => {
    var _a, _b;
    const theme = (0, styled_components_1.useTheme)();
    const { t, isReady } = (0, useTranslate_1.useTranslate)();
    const { productLineLogo, url, productUrl, partNumber, productName, price, productId, corePriceTotal, corePrice, coreQuantity, description, prices } = variant;
    const coreTotal = type === Types_1.VariantTypes.MINI_CART_VIEW
        ? corePriceTotal
        : (_b = (_a = prices === null || prices === void 0 ? void 0 : prices[0]) === null || _a === void 0 ? void 0 : _a.corePriceTotal) !== null && _b !== void 0 ? _b : corePriceTotal;
    const productPageUrl = url || productUrl;
    return (react_1.default.createElement(styled.TextBlockWrapper, { variantType: type },
        (type === Types_1.VariantTypes.CAROUSEL_VIEW || Types_1.VariantTypes.FULL_VIEW) &&
            productLineLogo &&
            productLineLogo.split(',').map(logo => (react_1.default.createElement(styled.LogoContainer, { key: logo },
                react_1.default.createElement(ProductLogo_1.default, { manufacturer: logo })))),
        react_1.default.createElement(styled.TextBlock, { ref: listRef },
            react_1.default.createElement(styled.GradientOverlay, { showGradient: showMoreButton && !isOpen }),
            productName && (react_1.default.createElement(styled.Title, { type: type === Types_1.VariantTypes.MINI_CART_VIEW ||
                    type === Types_1.VariantTypes.CAROUSEL_VIEW ||
                    type === Types_1.VariantTypes.SEARCH_VIEW
                    ? Typography_1.Types.EYEBROW
                    : type === Types_1.VariantTypes.FULL_VIEW && Typography_1.Types.INTRO_ON_IMAGE, variantType: type }, productPageUrl ? (react_1.default.createElement(styled.Link, { href: productPageUrl, onClick: onClick },
                type === Types_1.VariantTypes.MINI_CART_VIEW && productId && `${productId} `,
                productName)) : (react_1.default.createElement(react_1.default.Fragment, null,
                type === Types_1.VariantTypes.MINI_CART_VIEW && productId && `${productId} `,
                productName)))),
            price && type === Types_1.VariantTypes.MINI_CART_VIEW && canSeePrice && (react_1.default.createElement(styled.PkgAmountBlock, null,
                react_1.default.createElement(styled.Price, { type: Typography_1.Types.META_SMALL, variantType: type }, (price === null || price === void 0 ? void 0 : price.amount) === 0 ? (t('/haldex/product_page/no_price')) : (react_1.default.createElement(react_1.default.Fragment, null,
                    (0, Utils_1.currencyEncoder)(price && price.currencyCode),
                    (0, Utils_1.priceEncoder)(price.amount)))))),
            partNumber &&
                (!isReady ? (react_1.default.createElement(Skeleton_1.default, { width: theme.constants.filter.maxHeight })) : (react_1.default.createElement(styled.PartNumber, { type: Typography_1.Types.NAV_MEGA_LVL3, variantType: type }, partNumber))),
            price && coreTotal && coreQuantity && corePrice ? (react_1.default.createElement(styled.CoreInfo, { type: Typography_1.Types.EYEBROW_SMALL }, `${t('/haldex/cart_page/listing_page/products_table/core_charge')} (${coreQuantity} x ${(0, Utils_1.currencyEncoder)(price.currencyCode)}${(0, Utils_1.priceEncoder)(corePrice)}) ${(0, Utils_1.currencyEncoder)(price.currencyCode)}${(0, Utils_1.priceEncoder)(coreTotal)}`)) : null,
            description && react_1.default.createElement(Typography_1.default, { type: Typography_1.Types.BODY_2, dangerouslySetInnerHTML: { __html: description } })),
        showMoreButton && (react_1.default.createElement(styled.ReadMoreButton, { variant: Types_1.ButtonVariants.LINK_BUTTON, onClick: () => setIsOpen && setIsOpen(!isOpen) }, isOpen
            ? t('/haldex/product_page/button_labels/show_less')
            : t('/haldex/product_page/button_labels/read_more')))));
};
exports.default = (0, react_1.memo)(Text);
